/*
Replace
resourceName with your resource Name :) Take care about different writings!
/!\ ResourceName resourceName ResourceNames resourceNames /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
  defaultList,
  defaultListFail,
  defaultAddToDictionary,
} from "../defaultReducers";
import { defaultInitialState } from "../defaultInitialState";

export const creatorCommentsSlice = createSlice({
  name: "creatorComments",
  initialState: { ...defaultInitialState },
  reducers: {
    list: defaultList,
    listSuccess: (state, action) => {
      const responseList = action.payload?.obj?.data || [];
      const responseIds = action.payload?.obj?.data?.map((a) => a.id);
      const responseHeaders = action.payload.headers;

      if (responseHeaders && responseHeaders["total-count"])
        state.listTotalCount = parseInt(responseHeaders["total-count"], 10);
      if (responseHeaders && responseHeaders["current-page"])
        state.listPage = parseInt(responseHeaders["current-page"], 10);
      if (responseHeaders && responseHeaders["total-pages"])
        state.totalPages = parseInt(responseHeaders["total-pages"], 10);
      state.loadingList = false;
      state.loadedList = true;

      state.list = responseList;
      state.idsList = responseIds;

      responseList.forEach((entry) => (state.dictionary[entry.id] = entry));
    },
    listFail: defaultListFail,
    addToDictionary: defaultAddToDictionary,
    mergeDictionary: (state, action) => {
      state.dictionary = { ...state.dictionary, ...action.payload };
    },
  },
});
export const { list: listCreatorComments } = creatorCommentsSlice.actions;

export const actions = creatorCommentsSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const creatorComments = (state) =>
  state.creatorComments.idsList.map(
    (id) => state.creatorComments.dictionary[id]
  );
export const creatorComment = (state) =>
  state.creatorComments.showId &&
  state.creatorComments.dictionary[state.creatorComments.showId];
export const creatorCommentAttributes = (state) =>
  creatorComment(state)?.attributes;
export const creatorCommentRelationships = (state) =>
  creatorComment(state)?.relationships;
export const creatorCommentId = (state) => state.creatorComments.showId;

export const getCreatorComment = createSelector(
  (state) => state.creatorComments.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getCreatorCommentAttributes = createSelector(
  (state) => state.creatorComments.dictionary,

  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getCreatorCommentRelationships = createSelector(
  (state) => state.creatorComments.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export const getCreatorComments = createSelector(
  (state) => state.creatorComments.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    return ids && dictionary && ids.map((id) => dictionary[id]);
  }
);

export default creatorCommentsSlice.reducer;
